var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLikeuncheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    stroke: "#353535"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#353535",
    d: "M12.14 10c1.618 0 2.486 1.745 2.86 2.515.375-.773 1.235-2.51 2.863-2.51 1.029 0 2.137.654 2.137 2.091 0 1.721-2.372 3.925-5 6.5-2.629-2.576-5-4.78-5-6.5 0-1.338.982-2.097 2.14-2.096Zm0-1C10.55 9 9 10.094 9 12.096c0 2.33 2.785 4.713 6 7.904 3.215-3.19 6-5.573 6-7.904 0-2.005-1.549-3.091-3.137-3.091-1.102 0-2.223.521-2.863 1.619C14.357 9.521 13.239 9 12.14 9Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeuncheck);
export default __webpack_public_path__ + "static/media/likeuncheck.5ebb491d4eb04bca5ed3f14d8fd43a55.svg";
export { ForwardRef as ReactComponent };